const separator = Intl.NumberFormat(navigator.languages).format('1.1').charAt(1);
const pattern = new RegExp(`[^-+0-9${separator}]`, 'g');
const coalesce = (v1, v2) => isNaN(v1) ? v2 : v1;
const pf = (value, defaultValue) => coalesce(parseFloat(('' + value).replace(pattern, '').replace(separator, '.')), defaultValue ?? 0);

const round = (d, precision) => {
    if (precision === null || precision === undefined || isNaN(precision)) {
        precision = 2;
    }
    return pf(d).toFixed(precision) * 1;
}

const add = (n1, n2, precision) => round(pf(n1) + pf(n2), precision);
const subtract = (n1, n2, precision) => round(pf(n1) - pf(n2), precision);
const multiply = (n1, n2, precision) => round(pf(n1) * pf(n2), precision);
const divide = (n1, n2, precision) => round(pf(n1) / pf(n2), precision);
const sum = (all, precision) => {
    let total = 0;
    all.forEach(d => total = add(d, total, precision));
    return total;
}

/* Because javascript math is \uD83D\uDCA9 */
export const decimal = {
    add,
    subtract,
    multiply,
    divide,
    round,
    sum,
    parse: pf,
    coalesce,
}

export default decimal;
